import { AffineSlashMenuWidget, AIStarIcon } from '@blocksuite/affine/blocks';
import { t } from '@blocksuite/docnboard-i18n';

import { askAICommand } from '../../commands';

export function setupSlashMenuEntry(slashMenu: AffineSlashMenuWidget) {
  const menu = slashMenu.config.items.slice();

  // FIXME после переключения языка не обновляется
  menu.unshift({
    id: 'ask-ai',
    name: t('docnboard.ai.ask-ai'),
    icon: AIStarIcon,
    showWhen: () => {
      return true;
    },
    action: ({ rootComponent }) => {
      askAICommand(rootComponent.std);
    },
  });
  menu.unshift({ groupName: 'AI', id: 'ai' });

  slashMenu.config = {
    ...AffineSlashMenuWidget.DEFAULT_CONFIG,
    items: menu,
  };
}
